// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

common.View.create('common.canvas.blocks.custom.category.Block', {

    onDOMLoad() {
        this.initHideCategoryBlock();
        this.initSwipers();
    },

    initHideCategoryBlock()
    {
        // Category grid is empty?
        if (!this.element.data('canvas-editable') && !this.element.find('.categoryGrid > *').length) {
            this.element.hide();
        }
    },

    initSwipers()
    {
        let swiper = new Swiper('.swiper-slider', {
            spaceBetween: 30,
            watchOverflow: true,

            // If we need pagination
            pagination: {
                el: '.swiper2 .swiper-pagination',
                dynamicBullets: true,
            },

            // Navigation arrows
            navigation: {
                prevEl: '.swiper2 .swiper-button-prev',
                nextEl: '.swiper2 .swiper-button-next',
            },

            breakpoints: {
                0: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: 3
                }
            }
        });
    }

});
